module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_more.d98b7.png";